import { render, staticRenderFns } from "./TotalPrice.vue?vue&type=template&id=1c3bfb2a&"
import script from "./TotalPrice.vue?vue&type=script&lang=ts&"
export * from "./TotalPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports